/**
 * Constants for Payment Financing form
 */

export const NOT_APPLICABLE_FALLBACK = 'Not applicable for this Finance Provider';

const LUCID_FINANCING_PREFIX = 'Lucid Financing - ';

/**
 * Whether a subvention method is Embedded (case-insensitive)
 */
export const isEmbeddedSubventionMethod = (subventionMethod?: string | null): boolean =>
  subventionMethod?.toLowerCase() === 'embedded';

/**
 * Whether a financing application status is Contract Signed (case-insensitive)
 */
export const isContractSignedStatus = (applicationStatus?: string | null): boolean =>
  applicationStatus?.toLowerCase() === 'contract_signed';

/**
 * FinOps finance type for an order payment method, e.g. `Lucid Financing - Lease` → `Lease`
 */
export const getFinanceTypeFromPaymentMethod = (paymentMethod?: string | null): string =>
  paymentMethod?.startsWith(LUCID_FINANCING_PREFIX)
    ? paymentMethod.slice(LUCID_FINANCING_PREFIX.length)
    : '';

/**
 * Get financing type dropdown options
 */
export const getFinancingTypeOptions = (labels?: Record<string, string>) => [
  { label: labels?.financingTypeLoan ?? 'Loan', value: 'loan' },
  { label: labels?.financingTypeLease ?? 'Lease', value: 'lease' },
];

/**
 * Get financing subtype dropdown options
 */
export const getFinancingSubtypeOptions = (labels?: Record<string, string>) => [
  { label: labels?.financingSubtypePrivate ?? 'Private', value: 'private' },
  { label: labels?.financingSubtypeBusiness ?? 'Business', value: 'business' },
];

/**
 * Get application status dropdown options
 */
export const getApplicationStatusOptions = (labels?: Record<string, string>) => [
  { label: labels?.appStatusInitiated ?? 'App Initiated', value: 'app_initiated' },
  { label: labels?.appStatusInProgress ?? 'App In Progress', value: 'app_in_progress' },
  { label: labels?.appStatusApproved ?? 'Approved', value: 'approved' },
  { label: labels?.appStatusSubmitted ?? 'App Submitted', value: 'app_submitted' },
  { label: labels?.appStatusBooked ?? 'Booked', value: 'booked' },
  { label: labels?.appStatusCancelled ?? 'Cancelled', value: 'cancelled' },
  {
    label: labels?.appStatusContractPendingSignature ?? 'Contract Pending Signature',
    value: 'contract_pending_signature',
  },
  { label: labels?.appStatusContractSigned ?? 'Contract Signed', value: 'contract_signed' },
  {
    label: labels?.appStatusDecisionInProgress ?? 'Decision In Progress',
    value: 'decision_in_progress',
  },
  { label: labels?.appStatusDeclined ?? 'Declined', value: 'declined' },
];

/**
 * Get application decision dropdown options
 */
export const getApplicationDecisionOptions = (labels?: Record<string, string>) => [
  { label: labels?.appDecisionApproved ?? 'Approved', value: 'approved' },
  { label: labels?.appDecisionBooked ?? 'Booked', value: 'booked' },
  {
    label: labels?.appDecisionConditionallyApproved ?? 'Conditionally Approved',
    value: 'conditionally approved',
  },
  { label: labels?.appDecisionDeclined ?? 'Declined', value: 'declined' },
  { label: labels?.appDecisionPending ?? 'Pending', value: 'pending' },
];
